export const font = {
  heading: 'cappeletto-grotesk',
  body: 'neue-montreal',
}
